/**
 * 设置中心
 */
const settingRouter = [
  {
    path: '/setting/common',
    name: 'common',
    component: () => import('@/views/admin/setting/CommonSetting'),
    meta: { title: '公共设置' }
  },
  {
    path: '/setting/contract-type',
    name: 'contract-type-setting',
    component: () => import('@/views/admin/setting/ContractTypeList'),
    meta: { title: '合同设置' }
  },
  {
    path: '/setting/contract-type/add',
    name: 'contract-type-add',
    component: () => import('@/views/admin/setting/CreateOrEditContractType'),
    meta: { title: '新增合同类型', companyVerify: true, personVerify: true }
  },
  {
    path: '/setting/contract-type/edit/:id',
    name: 'contract-type-edit',
    component: () => import('@/views/admin/setting/CreateOrEditContractType'),
    meta: { title: '编辑合同类型', companyVerify: true, personVerify: true }
  },
  {
    path: '/setting/template-type',
    name: 'template-type-setting',
    component: () => import('@/views/admin/setting/ContractTemplateTypeList'),
    meta: { title: '合同模板设置' }
  },
  {
    path: '/setting/template-type/add',
    name: 'template-type-add',
    component: () => import('@/views/admin/setting/CreateOrEditContractTemplateType'),
    meta: { title: '新增模板类型', companyVerify: true, personVerify: true }
  },
  {
    path: '/setting/template-type/edit/:id',
    name: 'template-type-edit',
    component: () => import('@/views/admin/setting/CreateOrEditContractTemplateType'),
    meta: { title: '编辑模板类型', companyVerify: true, personVerify: true }
  }
]
export default settingRouter
